import { useState } from 'react';
import { faqItems } from '@/mocks/data';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-600 text-sm">
            关于亚洲精品一区二区的常见疑问解答
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl bg-background-100 border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => toggle(index)}
                className="w-full flex items-center justify-between px-6 py-5 text-left transition-colors hover:bg-background-200/50"
                aria-expanded={openIndex === index}
              >
                <span className="font-heading text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <div
                  className={`w-6 h-6 flex items-center justify-center rounded-full transition-all duration-300 flex-shrink-0 ${
                    openIndex === index
                      ? 'bg-primary-500 text-background-50 rotate-45'
                      : 'bg-background-300 text-foreground-600'
                  }`}
                >
                  <i className="ri-add-line text-sm"></i>
                </div>
              </button>

              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 pb-5">
                  <p className="text-foreground-600 text-sm leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}